import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Loading } from './LoadingComponent';
import { S3Uploader } from './S3UploaderComponent';
import { withRouter } from 'react-router-dom';
import { Button, Alert } from 'reactstrap';
import { postRequest } from '../redux/ActionCreators';

// import { Auth } from 'aws-amplify';

const mapStateToProps = state => {
  return {
    user_wm: state.user_wm
  };
};

class PortLoad extends Component {
  constructor(props){
      super(props);
      this.state = {
        msg:null
      };
    this.loadPortfolio = this.loadPortfolio.bind(this);
  }
  loadPortfolio(data){
    const res = postRequest(data, "load_portfolio", 0);
    return res;
  }
  
  render(){
      if(this.props.user_wm.isLogging){
        return(
          <div className='container'>
            <div className="row justify-content-center">
                <Loading />
            </div>
          </div>
        );
    } else {

      return(
          <div className='container'>
            <div className="row m-5 justify-content-center">
              <div className="col-auto">
                <h4>Carga de Portafolios</h4>
              </div>
            </div>
            <div className="row m-3 justify-content-center">
                <div className="col-6 m-2">
                    <S3Uploader
                      bucket="condor-queries"
                      dir="saa/"
                      button_label="Cargar Portafolio"
                      validator={this.loadPortfolio}
                      filename_var="load_params.saa_filename"
                      changeModel={this.props.changeModel}
                      other_params={{from_file:true}}
                    />
                </div>
            </div>
          </div>
          
      );
    }
  }
}

export default withRouter(connect(mapStateToProps)(PortLoad));
